import { FloatButton, Layout } from "antd";
import { Content } from "antd/es/layout/layout";
import { Outlet } from "react-router-dom";
import { MdTranslate } from "react-icons/md";
import { useTranslationContext } from "../hooks/useTranslationContext";
import { translatedLanguages } from "../constants/translation";

const AdminLayout = () => {
  const { setLanguage } = useTranslationContext();
  return (
    <Layout className="w-full lg:w bg-[#E7F2FF] font-roboto text-title">
      <FloatButton.Group
        trigger="click"
        icon={<MdTranslate size={20} />}
      >
        {translatedLanguages.map((lang) => (
          <FloatButton key={lang.code} description={lang.flag} onClick={() => setLanguage(lang.code)}>
            {lang.nativeName}
          </FloatButton>
        ))}
      </FloatButton.Group>
      <Content className="mx-auto bg-[#E7F2FF]">
        <Outlet />
      </Content>
    </Layout>
  );
};
export default AdminLayout;
